module.exports = __webpack_public_path__ + "assets/7b2297283865ed47f98c608d3539c219.mp3";